export default __webpack_public_path__ + "static/extract-balthazaurus-scroll-ea912de4da13b33022cdc5fde32aeca4.gif";